// @flow

import React, { type Node } from 'react';
import { Button, SectionTitle, SectionSubtitle, Separator } from '../../../atoms';

export function PaymentLocationsInfo(): Node {
  return (
    <section>
      <SectionTitle>Sucursales para pago</SectionTitle>
      <SectionSubtitle>Presente este recibo en cualquier sucursal Efecty.</SectionSubtitle>
      <Separator direction="vertical" size={4} />
      <Button
        as="a"
        block
        flat
        href="https://www.efecty.com.co/puntos-de-atencion"
        outline
        rel="noopener noreferrer"
        size="lg"
        target="_blank"
        type="primary"
      >
        Ver sucursal Efecty más cercana
      </Button>
    </section>
  );
}
